export const ROLES = {
  employee: { label: "Employee", labelGr: "Υπάλληλος", color: "#1B4332" },
  crew: { label: "Employee", labelGr: "Υπάλληλος", color: "#1B4332" },
  store_manager: { label: "Store Manager", labelGr: "Διευθυντής Καταστήματος", color: "#2D6A4F" },
  hr: { label: "HR", labelGr: "HR", color: "#7C3AED" },
  admin: { label: "Network Admin", labelGr: "Network Admin", color: "#0D2B1D" },
  super_admin: { label: "Super Admin", labelGr: "Super Admin", color: "#0D2B1D" },
  brand_manager: { label: "Brand Manager", labelGr: "Brand Manager", color: "#1D4ED8" },
  ops_manager: { label: "Ops Manager", labelGr: "Ops Manager", color: "#0F766E" },
  chef: { label: "Employee", labelGr: "Υπάλληλος", color: "#B45309" },
};

export const PLATFORM_USER_ROLE_OPTS = [
  { v: "employee", l: "Employee" },
  { v: "store_manager", l: "Store Manager" },
  { v: "admin", l: "Network Admin" },
  { v: "brand_manager", l: "Brand Manager" },
  { v: "ops_manager", l: "Ops Manager" },
  { v: "hr", l: "HR" },
];

export const JOB_TITLES = [
  "Store Manager",
  "Supervisor",
  "Kitchen Staff",
  "Kitchen Crew",
  "Kitchen Staff L",
  "Cleaning Crew",
  "HR",
  "Admin",
];

export const GROUPS = [
  { key: "supervisor", label: "Store Manager / Supervisor", labelGr: "Διευθυντής / Supervisor" },
  { key: "service", label: "Service Crew", labelGr: "Service Crew" },
  { key: "kitchen", label: "Kitchen Staff", labelGr: "Kitchen Staff" },
  { key: "cleaning", label: "Cleaning Crew", labelGr: "Cleaning Crew" },
];

export const KITCHEN_STAFF_L_SPECIALTY = "Kitchen Staff L";

export function groupFromJobTitle(jobTitle) {
  if (jobTitle === "Store Manager" || jobTitle === "Supervisor") return "supervisor";
  if (jobTitle === "Kitchen Staff") return "kitchen";
  if (jobTitle === "Kitchen Staff L") return "cleaning";
  if (jobTitle === "Kitchen Crew") return "kitchen";
  if (jobTitle === "Cleaning Crew") return "cleaning";
  return "service";
}

export function ganttDisplayRoleKey(role) {
  const raw = String(role || "").trim().toLowerCase();
  if (raw === "kitchen staff" || raw === "kitchen staff l") return "boh";
  if (raw === "kitchen") return "boh";
  if (raw === "cleaning") return "boh";
  return raw || "service";
}

export function roleFromJobTitle(jobTitle) {
  const jt = String(jobTitle || "").trim();
  if (jt === "Store Manager") return "Store Manager";
  if (jt === "Supervisor") return "Supervisor";
  if (jt === "Kitchen Staff" || jt === "Kitchen Crew") return "Kitchen Staff";
  if (jt === "Kitchen Staff L") return "Kitchen Staff L";
  if (jt === "Cleaning Crew") return "Cleaning Crew";
  return jt || "Service Crew";
}

/** Team, plus the Foxline specialty when it is more specific than the team name. */
export function employeeSpecialtyLabel(emp, lang = "en") {
  const jobTitle = String(emp?.job_title ?? emp?.jobTitle ?? emp?.specialty_name ?? "").trim();
  const groupKey = schedulingGroupFor(emp || {});
  const group = GROUPS.find((entry) => entry.key === groupKey);
  const team = group ? (lang === "gr" ? group.labelGr : group.label) : "";
  const specialty = jobTitle ? roleFromJobTitle(jobTitle) : "";
  if (
    team
    && specialty
    && specialty.toLowerCase() !== team.toLowerCase()
    && !team.toLowerCase().includes(specialty.toLowerCase())
  ) {
    return `${team} · ${specialty}`;
  }
  return specialty || team;
}

export function isKitchenStaffL(emp) {
  const jt = emp?.job_title ?? emp?.jobTitle ?? emp?.specialty_name ?? "";
  return String(jt).trim() === KITCHEN_STAFF_L_SPECIALTY;
}

/** Scheduling pool group: job-title rules override Foxline API group (e.g. Kitchen Staff L → cleaning). */
export function schedulingGroupFor(emp) {
  const jobTitle = String(emp?.job_title ?? emp?.jobTitle ?? emp?.specialty_name ?? "").trim();
  if (jobTitle === KITCHEN_STAFF_L_SPECIALTY || jobTitle === "Kitchen Staff") {
    return groupFromJobTitle(jobTitle);
  }
  if (isKitchenStaffL(emp)) return "cleaning";
  const fromApi = String(emp?.group ?? "").trim().toLowerCase();
  if (fromApi) return fromApi;
  return groupFromJobTitle(jobTitle);
}

export { contractedShiftHoursSelectOptions } from "../features/schedule/scheduleHelpers";
